// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"d911dcf7","970":"8032be88"}[chunkId] + ".chunk.js";
};